import AppModel from '@/models/AppModel'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  getApi: (bvModal, params, callbackSuccess = null) => {
    return AppModel.get(
      'material/detail',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }

        AppModel.validateStatus(res.data)

        if (callbackSuccess !== null) {
          callbackSuccess(res.data)
        }

        return Promise.resolve(res.data)
      },
      (res) => {}
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/MaterialDetailModel.js